function escapeHtml (value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function setImageLoading (trigger, loading) {
  if (!trigger) return
  trigger.classList.toggle('reviews-carousel-section__image-wrapper--loading', loading)
  if (loading) {
    trigger.setAttribute('aria-busy', 'true')
  } else {
    trigger.removeAttribute('aria-busy')
  }
}

function preloadImage (src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('Image load failed'))
    img.src = src
  })
}

function openReviewImageModal (src) {
  const modal = document.querySelector('.reusable-modal')
  const modalBody = modal?.querySelector('.reusable-modal__body')
  if (!modal || !modalBody || !src) return false

  modalBody.innerHTML = `
    <div class="product-reviews__photo-modal flex items-center justify-center">
      <img src="${escapeHtml(src)}" alt="" class="product-reviews__photo-modal-img max-w-full max-h-[80vh] object-contain mx-auto">
    </div>
  `

  window.dispatchEvent(
    new CustomEvent('open:modal', {
      detail: {
        padding: 'none',
        headerClassAdd: ['absolute', 'top-0', 'left-0', 'right-0', 'z-20', 'block'],
        headerClassRemove: ['border-b', 'mb-4', 'pb-2', 'grid'],
        closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20', 'bg-white', 'rounded-full', 'p-1'],
        closeClassRemove: [],
      },
    }),
  )

  return true
}

async function handleReviewImageClick (event) {
  const trigger = event.target.closest('.reviews-carousel-section__image-wrapper[data-image-src]')
  if (!trigger) return
  if (trigger.classList.contains('reviews-carousel-section__image-wrapper--loading')) return

  const src = trigger.dataset.imageSrc
  if (!src) return

  event.preventDefault()
  event.stopPropagation()

  setImageLoading(trigger, true)

  try {
    await preloadImage(src)
  } catch {
    setImageLoading(trigger, false)
    window.open(src, '_blank', 'noopener,noreferrer')
    return
  }

  setImageLoading(trigger, false)

  if (!openReviewImageModal(src)) {
    window.open(src, '_blank', 'noopener,noreferrer')
  }
}

document.addEventListener('click', handleReviewImageClick)
